export const maxRegistrations = 5
